import React from "react";
import { founders, brand } from "../data/siteData";
import "../styles/WhatsAppButton.css";

// Floating quick-contact button — the fastest path from "I like this"
// to "I've asked about it" for a handmade/export business, where most
// enquiries start as a WhatsApp chat rather than a form.
export default function WhatsAppButton() {
  const rawPhone = founders?.[0]?.phone || "";
  const digits = rawPhone.replace(/[^\d]/g, "");
  if (!digits) return null;

  const message = encodeURIComponent(
    `Hi ${brand.name}, I'd like to know more about your handcrafted pieces.`
  );

  return (
    <a
      className="tp-whatsapp"
      href={`https://wa.me/${digits}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="tp-whatsapp__ping" aria-hidden="true" />
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M12.02 2C6.5 2 2.02 6.48 2.02 12c0 1.85.5 3.58 1.36 5.07L2 22l5.08-1.33A9.94 9.94 0 0 0 12.02 22C17.55 22 22 17.52 22 12S17.55 2 12.02 2Zm0 18.1c-1.68 0-3.24-.5-4.55-1.36l-.33-.2-3.02.79.8-2.94-.21-.3A8.1 8.1 0 0 1 3.9 12c0-4.48 3.65-8.1 8.12-8.1 4.48 0 8.11 3.62 8.11 8.1s-3.63 8.1-8.11 8.1Zm4.46-6.07c-.24-.12-1.44-.71-1.67-.8-.22-.08-.38-.12-.55.12-.16.24-.63.8-.77.96-.14.16-.28.18-.52.06-.24-.12-1.02-.38-1.94-1.2-.72-.64-1.2-1.43-1.35-1.67-.14-.24-.02-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.8-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.3-.22.24-.85.83-.85 2.02s.87 2.35 1 2.51c.12.16 1.72 2.63 4.17 3.69.58.25 1.04.4 1.39.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28Z" />
      </svg>
    </a>
  );
}
